import { useGetOtherPreferences } from "@/hooks/requests/other-preferences/use-get-other-preferences";
import { cn } from "@/utils/cn";
import { memo, useState } from "react";
import { EditDailyCaloriesModal } from "../edit-daily-calories-modal";
import { EditMacrosModal } from "../edit-macros-modal";
import { NutritionInfoModal } from "../nutrition-info-modal";
import { NutritionSummaryCard } from "../nutrition-summary-card";

interface ProfileNutritionCardProps {
  className?: string;
}

type ModalType = null | "calories-info" | "macros-info" | "edit-calories" | "edit-macros";

export const ProfileNutritionCard = memo(function ProfileNutritionCard({
  className,
}: ProfileNutritionCardProps) {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const { otherPreferences, isLoading } = useGetOtherPreferences();
  const showCaloriesAndMacros = otherPreferences?.showCaloriesAndMacros ?? false;

  if (isLoading || !showCaloriesAndMacros) {
    return null;
  }

  const handleEditClick = () => {
    if (activeModal === "macros-info") {
      setActiveModal("edit-macros");
    } else if (activeModal === "calories-info") {
      setActiveModal("edit-calories");
    }
  };

  const getModalContent = () => {
    if (activeModal === "calories-info") {
      return {
        title: "I've got you!",
        description:
          "Nutricoach is actively calculating calories and macros for you so you don't have to count calories and edit targets.",
        buttonText: "Edit daily calories",
      };
    } else if (activeModal === "macros-info") {
      return {
        title: "I've got you!",
        description:
          "Nutricoach is actively calculating calories and macros for you so you don't have to count calories and edit targets.",
        buttonText: "Edit Macros",
      };
    }
    return null;
  };

  const modalContent = getModalContent();

  return (
    <>
      <div className={cn("flex w-full flex-col gap-6", className)}>
        <NutritionSummaryCard variant="calories" onAmend={() => setActiveModal("calories-info")} />
        <NutritionSummaryCard variant="macros" onAmend={() => setActiveModal("macros-info")} />
      </div>

      {modalContent && (
        <NutritionInfoModal
          isOpen={activeModal === "calories-info" || activeModal === "macros-info"}
          onDismiss={() => setActiveModal(null)}
          title={modalContent.title}
          description={modalContent.description}
          buttonText={modalContent.buttonText}
          onButtonClick={handleEditClick}
        />
      )}

      <EditDailyCaloriesModal
        isOpen={activeModal === "edit-calories"}
        onDismiss={() => setActiveModal(null)}
      />

      <EditMacrosModal
        isOpen={activeModal === "edit-macros"}
        onDismiss={() => setActiveModal(null)}
      />
    </>
  );
});
